module.exports = __webpack_public_path__ + "components/country-flag/static/ke-05548d176e5ef676ecdd6dc0755a1887.svg";